import { Component, Inject, Input, OnInit } from '@angular/core';
import { Category } from '../../../shared/category/category.model';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { Process } from '../store/process.model';
import { Store } from '@ngrx/store';
import * as fromShared from '../store';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'ef-process-list',
    templateUrl: './process-list.component.html',
    styleUrls: ['./process-list.component.scss'],
    standalone: false
})
export class ProcessListComponent implements OnInit {
    // private _processService: ProcessService;
    private _category: number;
    constructor(@Inject(LoggingService) private log: LoggingService, private ss: StateService,  private store: Store<fromShared.State>) {}
    @Input() public category: Category;
    public processes?: Process[];

    ngOnInit() {
        this.log.debug({
            type: 'ProcessListComponent:ngOnInit',
            category: this.category
        });
        // this.processes = this._processService.getProcesses(this.categoryId);

        this.processes = this.category.UserProcesses;
    }

    public goto(process: Process) {
        this.store.dispatch(fromShared.clearProcess());
        this.store.dispatch(fromShared.upsertProcess({ process }));
        const stateName =
            process?.RouteName?.toLowerCase().replace('/', '.') ?? 'main';
        this.log.debug({ type: 'ProcessComponent:goto', process, stateName });
        this.ss.go(stateName, { process: { ...process, catId: this.category.CategoryId } });
        // this.app.onMenuButtonClick(null);
    }
}
